import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Twentysecondtheme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Mint Fresh */
            --primary: #10b981;       /* Emerald 500 */
            --primary-dark: #047857;  /* Emerald 700 */
            --bg-light: #ecfdf5;      /* Emerald 50 */
            --text-dark: #065f46;     /* Emerald 900 */
            --white: #ffffff;
            --font-family: 'Quicksand', sans-serif;
            --radius: 25px;
        }

        body { font-family: var(--font-family); background-color: var(--white); color: var(--text-dark); margin: 0; }
        .container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
        
        .navbar { padding: 20px; background: var(--bg-light); border-radius: 0 0 20px 20px; display: flex; justify-content: space-between; align-items: center; }
        .brand { font-size: 1.5rem; font-weight: 700; color: var(--primary-dark); }
        .nav-links a { margin-left: 20px; color: var(--text-dark); text-decoration: none; font-weight: 600; }
        
        .hero { background: var(--bg-light); padding: 80px 40px; border-radius: 30px; margin: 30px auto; text-align: center; max-width: 900px; }
        .hero h1 { font-size: 3rem; color: var(--primary-dark); margin-bottom: 20px; }
        .btn { background: var(--primary); color: white; padding: 12px 25px; border-radius: 50px; font-weight: 700; border: none; cursor: pointer; transition: 0.2s; }
        .btn:hover { background: var(--primary-dark); transform: scale(1.05); }

        .section-title { text-align: center; font-size: 2.2rem; color: var(--primary-dark); margin: 60px 0 40px; }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 30px; }
        .card { background: var(--bg-light); padding: 30px; border-radius: var(--radius); text-align: center; transition: 0.3s; border: 2px solid transparent; }
        .card:hover { border-color: var(--primary); background: white; box-shadow: 0 10px 20px rgba(16, 185, 129, 0.1); }
        
        .icon { font-size: 2.5rem; margin-bottom: 15px; color: var(--primary); }
        .product-img { width: 100%; height: 200px; object-fit: cover; border-radius: 15px; margin-bottom: 15px; }

        .footer { background: var(--primary-dark); color: white; padding: 40px; margin-top: 80px; text-align: center; border-radius: 20px 20px 0 0; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;600;700&display=swap" rel="stylesheet" />

            <div className="container">
                <nav className="navbar">
                    <div className="brand">{get_data.service_name}</div>
                    <div className="nav-links">
                        <a href="#">Home</a>
                        <a href="#services">Services</a>
                        <a href="#products">Store</a>
                    </div>
                </nav>
            </div>

            <div className="container">
                <header className="hero">
                    <h1>Fresh & Clean Solutions.</h1>
                    <p style={{fontSize: '1.1rem', marginBottom: '30px'}}>We bring a breath of fresh air to everything we do.</p>
                    <a href="#contact" className="btn">Get Started</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                </header>

                <h2 className="section-title" id="services">What We Do</h2>
                <div className="grid">
                     {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                        <div className="card" key={index}>
                             <div className="icon">
                                 {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '50px', height: '50px', borderRadius: '50%'}} alt=""/> : '☘'}
                             </div>
                             <h3>{item.name}</h3>
                             <p>{item.description}</p>
                             <div style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                                 <a href={`tel:${get_data.mobile}`} style={{flex: 1, color: 'var(--primary-dark)', border: '1px solid var(--primary)', padding: '8px', borderRadius: '20px', fontWeight: 'bold'}}>Call</a>
                                 <a href="#contact" style={{flex: 1, background: 'var(--primary)', color: 'white', padding: '8px', borderRadius: '20px', fontWeight: 'bold'}}>Enquiry</a>
                             </div>
                        </div>
                     )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                </div>

                <h2 className="section-title" id="products">Fresh Picks</h2>
                <div className="grid">
                     {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="card" key={index} style={{textAlign: 'left'}}>
                             {item.featured_image ? (<img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} className="product-img" alt={item.service_name}/>) : (<div className="product-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555',  }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                             <h3>{item.service_name}</h3>
                             {item.price && <div style={{color: 'var(--primary)', fontWeight: 'bold', fontSize: '1.1rem', margin: '5px 0'}}>₹{item.price}</div>}
                             <button onClick={() => addToCart(item)} className="btn" style={{marginTop: '10px', width: '100%'}}>Add to Cart</button>
                        </div>
                     ))}
                </div>
            </div>

            <footer className="footer" id="contact">
                <h3>{get_data.service_name}</h3>
                <p style={{opacity: 0.8}}>{get_data.business_location_name}</p>
                <div style={{marginTop: '20px', fontSize: '0.9rem'}}>
                    &copy; {new Date().getFullYear()} All Rights Reserved.
                </div>
            </footer>
        </>
    );
};

export default Twentysecondtheme;
